<template>
    <div>
        <v-progress-linear v-if="initial_loading" height="2" :indeterminate="true"></v-progress-linear>
        <v-layout align-center justify-center row fill-height>
            <span v-if="initial_loading_fail" style="font-size: 20px; color: dimgrey">Erro ao carregar configurações</span>
        </v-layout>
        <v-layout v-if="initial_loading === false && initial_loading_fail === false">
            <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-card-title primary-title >
                        <h3 class="headline mb-0">Impressão</h3>
                        <br>

                        <v-container fluid >

                            <!--Fatura-->
                            <span class="mTitle">Fatura</span>
                            <hr style="margin-bottom: -10px">
                            <v-radio-group v-model="invoiceFormat" row>
                                <v-radio label="A4" value="A4"></v-radio>
                                <v-radio label="A5" value="A5"></v-radio>
                            </v-radio-group>

                            <!--Fatura-Recibo-->
                            <br>
                            <span class="mTitle">Fatura-Recibo</span>
                            <hr style="margin-bottom: -10px">
                            <v-radio-group v-model="invoiceReceiptFormat" row>
                                <v-radio label="A4" value="A4"></v-radio>
                                <v-radio label="A5" value="A5"></v-radio>
                            </v-radio-group>

                            <!--Recibo-->
                            <br>
                            <span class="mTitle">Recibo</span>
                            <hr style="margin-bottom: -10px">
                            <v-radio-group v-model="ReceiptFormat" row>
                                <v-radio label="A4" value="A4"></v-radio>
                                <v-radio label="A5" value="A5"></v-radio>
                            </v-radio-group>

                        </v-container>

                    </v-card-title>

                    <v-card-actions style="margin-top: -20px; margin-right: 20px">
                        <v-spacer></v-spacer>
                        <!--<v-flex xs3 offset-xs9 align-end>-->
                            <div >
                                <v-btn v-if="!loading" flat color="blue" @click="save">Guardar</v-btn>
                                <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                            </div>
                        <!--</v-flex>-->
                    </v-card-actions>
                </v-card>
            </v-flex>

        </v-layout>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {eventBus} from "../../main";

    export default {
        created () {
            this.loadingDatas();
        },

        data(){
            return {
                initial_loading: true,
                initial_loading_fail: false,
                loading: false,

                invoiceFormat: "",
                invoiceReceiptFormat: "",
                ReceiptFormat: "",

            }
        },

        computed: {
            ...mapGetters([
                'getToken'
            ]),
            loggedUser:{
                get() {
                    return this.$store.getters.loggedUser;
                },
                set(value){
                    this.$store.dispatch('loggedUser', value);
                }
            },

            companyId(){
                try{
                    return this.loggedUser.group.company.id;
                }catch (e) {
                    return '';
                }
            },
        },

        methods: {

            loadingDatas(){
                this.initial_loading = true;
                this.initial_loading_fail = false;

                try{
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get("settings/"+this.companyId)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.handleErrorCodeMessage(response.data);
                                this.initial_loading_fail = true;
                                return;
                            }
                            // if(!this.isOkFromServer(response)){
                            //     return;
                            // }

                            this.setSettings(response.data.response);

                            this.initial_loading_fail = false;

                        }).catch(error => {
                            this.consoleLog(error);
                            this.initial_loading_fail = true;
                        this.showSnackBar('Ocorreu um erro. Por favor tente novamente', 'error');
                    }).finally(()=>{
                        this.initial_loading = false;
                    });
                }catch (e) {
                    console.log(e);
                    this.initial_loading_fail = true;
                }
            },

            setSettings(response){
                if (response === "Company settings not found") {
                    this.invoiceFormat = "A4";
                    this.invoiceReceiptFormat = "A4";
                    this.ReceiptFormat = "A4";
                }else{
                    this.invoiceFormat = response.invoice_format;
                    this.invoiceReceiptFormat = response.invoice_receipt_format;
                    this.ReceiptFormat = response.receipt_format;
                }
            },

            save(){
                try{
                    if(this.loggedUser === null) {
                        this.showSnackBar('Ocorreu um erro ao atualizar configurações', 'error');
                        return;
                    }


                    this.loading = true;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('settings/'+this.companyId, {
                        invoice_format: this.invoiceFormat,
                        invoice_receipt_format: this.invoiceReceiptFormat,
                        receipt_format: this.ReceiptFormat,

                    }).then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        // let updatedArticle = response.data.response;
                        // eventBus.$emit('onArticleAdded', updatedArticle, '');
                        this.showSnackBar('Configurações salvas com sucesso', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        // eventBus.$emit('onArticleAdded', null, 'Ocorreu um erro ao atualizar artigo');
                        this.showSnackBar('Ocorreu um erro ao atualizar configurações da impressão!', 'error');
                    }).finally( ()=> {
                        this.loading = false;
                    });
                }catch (e) {
                    console.log(e);
                    this.showSnackBar('Ocorreu um erro ao atualizar configurações da impressão', 'error');
                    this.loading = false;
                }
            }
        }

    }
</script>


<style scoped>
    .mTitle{
        color: grey;
        font-size: 16px;
    }
</style>